import { useEffect, useRef } from 'react'
import './HeroSection.css'

export default function HeroSection() {
  const counterRef = useRef(null)

  useEffect(() => {
    const el = counterRef.current
    if (!el) return
    let start = null
    const target = 87
    const duration = 2000
    const update = (now) => {
      if (!start) start = now
      const progress = Math.min((now - start) / duration, 1)
      const eased = 1 - Math.pow(1 - progress, 3)
      el.textContent = Math.round(eased * target)
      if (progress < 1) requestAnimationFrame(update)
    }
    const t = setTimeout(() => requestAnimationFrame(update), 600)
    return () => clearTimeout(t)
  }, [])

  return (
    <section className="hero">
      <div className="hero-glow-2" />
      <div className="hero-inner">
        <div className="hero-left">
          <div className="hero-eyebrow">Tecnologia · Gestão · Resultados</div>
          <h1>Tecnologia <em>aliada</em> à gestão eficiente de resultados.</h1>
          <p className="hero-desc">
            Desenvolvemos sistemas web, apps mobile e oferecemos consultoria estratégica para que prefeituras, autarquias e empresas tomem decisões guiadas por dados.
          </p>
          <div className="hero-actions">
            <a href="https://wa.link/gptqwc" target="_blank" rel="noopener" className="btn-primary">
              Solicitar proposta →
            </a>
            <a href="#sobre" className="btn-ghost">Conheça a Orken</a>
          </div>
          <div className="hero-badges">
            <span className="badge">LGPD compliant</span>
            <span className="badge">Apps iOS · Android</span>
            <span className="badge">Cloud first</span>
          </div>
        </div>

        <div className="hero-card">
          <div className="card-header">
            <span className="card-title">Indicador de gestão</span>
            <span className="card-badge-live">Tempo real</span>
          </div>
          <div className="metric-big">
            <div className="label">Eficiência geral</div>
            <div className="value">
              <span ref={counterRef}>0</span>
              <span style={{ fontSize: 28, color: 'var(--text-muted)', marginLeft: 2 }}>%</span>
              <span className="delta">+12%</span>
            </div>
          </div>
          <div className="metrics-grid">
            {[{l:'Eficiência operacional',v:84},{l:'Atendimento ao cidadão',v:72},{l:'Receita projetada',v:91}].map(m=> (
              <div className="metric-row" key={m.l}>
                <div className="metric-row-header">
                  <span className="metric-row-label">{m.l}</span>
                  <span className="metric-row-value">{m.v}%</span>
                </div>
                <div className="bar-track"><div className="bar-fill" style={{width:`${m.v}%`}} /></div>
              </div>
            ))}
          </div>
          <div className="card-footer">
            <div className="card-footer-item"><div className="f-label">Personalizado</div><div className="f-val">100%</div></div>
            <div className="card-footer-item"><div className="f-label">Sob medida</div><div className="f-val" style={{fontSize:11,marginTop:4}}>Para sua operação</div></div>
          </div>
          <div className="card-tag-row">
            {['React','Node.js','TypeScript','PostgreSQL','Flutter','AWS'].map(t=><span className="card-tag" key={t}>{t}</span>)}
          </div>
        </div>
      </div>
    </section>
  )
}
